import { CommonUI } from "@src/common/CommonUI/CommonUI";
import { IllustrationBG } from "@src/common/IllustrationBG/IllustrationBG";
import { PageLayout } from "@src/common/PageLayout";
import { MEDIA_QUERIES } from "@src/constants/media-queries";
import { useMediaQuery } from "@uhg-abyss/web/hooks/useMediaQuery";
import { Fragment } from "react";
import { NotFoundCard } from "./NotFoundCard";

export const NotFound = () => {
  const isMobile = useMediaQuery(MEDIA_QUERIES.mobileMax);

  return (
    <PageLayout css={{ paddingBottom: isMobile ? "0" : "50px" }}>
      <IllustrationBG />
      <div
        data-testid="test-id-page-not-found-content"
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
        }}
      >
        <CommonUI
          headingText="Page Not Found"
          metaTitle="Page Not Found"
          bodyText={<Fragment></Fragment>}
          FormComponent={() => {
            return <NotFoundCard isMobile={isMobile} />;
          }}
        />
      </div>
    </PageLayout>
  );
};
